module.exports = __webpack_public_path__ + "static/media/photo103.5a98a8c0.jpg";